import { LgcyEnphaseBomResults } from '../types/lgcy-bom.types';

/** Links an Enphase accessory NetSuite item to the LGCY BOM field that provides its quantity */
export interface EnphaseAccessoryItem {
  /** NetSuite external ID (e.g. "11242") */
  readonly externalId: string;
  /** Field in the calculated LGCY Enphase BOM results providing the quantity */
  readonly quantityField: keyof LgcyEnphaseBomResults;
}

/**
 * NetSuite accessory items that must be attached to every LGCY project
 * with Enphase microinverters. Quantities come from the LGCY BOM calculation
 * (see calculateLgcyBom in utils/lgcy-bom.utils.ts).
 */
export const ENPHASE_ACCESSORY_ITEMS: readonly EnphaseAccessoryItem[] = [
  { externalId: '11242', quantityField: 'cable_landscape' }, // Q Cable Landscape (60 Cell)
  { externalId: '11230', quantityField: 'cable_female_connector' }, // Q Cable Female Connector
  { externalId: '11250', quantityField: 'cable_male_connector' }, // Q Cable Male Connector
  { externalId: '11270', quantityField: 'cable_sealing_cap' }, // Q Cable Sealing Cap
  { externalId: '11280', quantityField: 'cable_terminator_cap' }, // Q Cable Terminator Cap
];
